export default __webpack_public_path__ + "static/media/article-5.dd7cba26.png";